export default [
  {
    imageUrl: 'https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_side-income.png',
    subTitle: 'สมัครเป็นพาร์ทเนอร์คนขับ ไรเดอร์ หรือแมสเซนเจอร์กับแอร์เอเชียเพื่อหารายได้พิเศษในเวลาว่าง ทำงานเสริม เพิ่มยอดเงินในบัญชีได้ง่ายๆ',
    title: 'รายได้ที่มากขึ้น'
  },
  {
    imageUrl: 'https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_flexible-hours.png',
    subTitle: 'พาร์ทเนอร์คนขับ airasia ride ไรเดอร์ airasia food และแมสเซนเจอร์ airasia xpress สามารถกำหนดเวลาและสถานที่ในการรับงานได้เองอย่างอิสระ ให้คุณเป็นนายตัวเองได้เต็มที่ ยิ่งขยันมาก ยิ่งหาเงินได้มาก!',
    title: 'อิสระในการรับงาน'
  },
  {
    imageUrl: 'https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_incentive.png',
    subTitle: 'เมื่อร่วมเป็นพาร์ทเนอร์แอร์เอเชีย คุณจะได้รับค่าตอบแทนและอินเซนทีฟตามการรับงาน ทั้งยังได้รับสิทธิพิเศษอื่นๆ อีกมากมาย',
    title: 'ผลตอบแทนที่คุ้มค่า'
  }
]
